import { render } from "./SVGEdit.vue?vue&type=template&id=ea3a5098"
import script from "./SVGEdit.vue?vue&type=script&lang=js"
export * from "./SVGEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__